import { ReactNode } from 'react'
import { useAppSelector } from '../../../../redux/hooks.ts'
import { selectThemeStyle } from '../../../../features/setting/setting.slice.ts'
import { useIsMobile } from '../../../../common/hooks/use-is-mobile.ts'

interface IdeaSummaryInfoBoxProps {
  children: ReactNode
}

export const IdeaSummaryInfoBox: React.FC<IdeaSummaryInfoBoxProps> = ({
  children,
}) => {
  const themeStyle = useAppSelector(selectThemeStyle)
  const isMobile = useIsMobile(768)

  return (
    <div
      style={{
        padding: isMobile ? '16px 8px' : '12px 24px',
        justifyContent: 'center',
        alignItems: 'left',
        textAlign: 'left',
        gap: '4px',
        flex: '1 0 0',
        borderRadius: themeStyle.borderRadiusLG,
        border: `1px solid ${themeStyle.sumCardOutline}`,
        background: themeStyle.sumCardBg,
        boxShadow: themeStyle.sumCardBoxShadow,
        backdropFilter: 'blur(4px)',
        height: '100%',
        minWidth: 0, // Prevent overflow
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          flex: '1 0 0',
          height: '100%',
        }}
      >
        {children}
      </div>
    </div>
  )
}
